import React from 'react'
import PropTypes from 'prop-types'
import { formatPhoneNumber } from '../../utils/phone-number'
import './GuestCommunication.css'

export const GuestCommunication = ({ curbsideSelected, guestCommunication = '', phone }) => {
  guestCommunication = !!guestCommunication && guestCommunication.trim()
  if (guestCommunication && guestCommunication.length) {
    return <p data-testid='guest-communication-text' styleName='text dark'>{guestCommunication}</p>
  }
  if (curbsideSelected) {
    return (
      <div>
        <p styleName='call'>Call upon arrival</p>
        <a href={`tel:${phone}`} styleName='phone'>{formatPhoneNumber(phone)}</a>
      </div>
    )
  }
  return null
}

GuestCommunication.propTypes = {
  curbsideSelected: PropTypes.bool.isRequired,
  guestCommunication: PropTypes.string,
  phone: PropTypes.string
}
